export const PROFES_CONTENT = {
    lessons: {
        // profes.inicio-agenda — «Tu inicio y tu agenda» — roles: teacher (Profesor) — pantalla: "profes.home" — práctica: no
        "profes.inicio-agenda": {
            summary: "Aprendés a usar el portal de profesores desde el celular: el inicio con todas tus pantallas y la Agenda, con tus clases de la semana (inscriptos contra cupo, presentes, reemplazos), tus clases semanales y las pestañas Avisos, Clases de prueba e Historial. Entendés por qué el portal no toca plata y por qué la grilla es de Coordinación.",
            keyPoints: [
                "El portal es tuyo y se usa desde el celular: tus clases, tus fichadas y tu liquidación. No se toca plata.",
                "La Agenda muestra tus clases de la semana día por día con hora, disciplina, salón, local e inscriptos contra cupo, y si la das como reemplazo.",
                "Mientras la clase no se consolida, los presentes dicen «sin consolidar», no cero; a los quince minutos de empezada se cierra la asistencia y aparece el número real.",
                "Con cuatro o más clases semanales en la grilla figurás habilitado para alumnos personalizados; es información para administración.",
                "El aviso de clase sin inscriptos a una hora de empezar no cancela nada: si hay uno solo anotado, la clase se da igual.",
                "No podés cancelar clases, cambiar cupos ni tocar la grilla: es de Coordinación. Si no vas a poder dar una clase, avisá tu ausencia por el portal apenas lo sepas.",
            ],
            estimatedMin: 5,
            contentVersion: 2,
        },
        // profes.tomar-lista — «Tomar lista en la clase» — roles: teacher (Profesor) — pantalla: "profes.lista-clase" — práctica: sí
        "profes.tomar-lista": {
            summary: "Aprendés a tomar lista desde el celular: abrís la clase desde tu Agenda, ves la lista moverse en vivo mientras los socios escanean el QR del salón (con el ícono de lesiones y objetivos de quien los declaró), marcás presente a quien no pudo escanear, sumás walk-ins dentro de los quince minutos de tolerancia y consolidás. Entendés por qué esa lista es la que vale y quién la corrige después.",
            keyPoints: [
                "La lista de clase es la que vale: de ahí salen las faltas de los socios, los premios por presentes y tu liquidación.",
                "Cuando el socio escanea el QR del salón, pasa solo de Reservados a Presentes. El ícono al lado del nombre muestra las lesiones y objetivos que declaró.",
                "Desde que arranca la clase tenés quince minutos de tolerancia para marcar presente a quien no pudo escanear y sumar walk-ins, que entran sólo si hay cupo y su plan lo permite.",
                "Al consolidar, los reservados que no marcaron presente pasan a ausentes con falta. Si no consolidás vos, al vencer la tolerancia el sistema consolida solo.",
                "Si fuiste y no vino nadie, marcás «Dictada sin alumnos» en Mis clases; la valida el coordinador y recién ahí se paga.",
                "Consolidada, la lista se congela: la corrige sólo Coordinación, con motivo. Si dice «sin conexión en vivo», volvé a entrar a la clase desde la agenda.",
            ],
            estimatedMin: 7,
            contentVersion: 2,
        },
        // profes.fichar — «Fichar entrada y salida» — roles: teacher (Profesor) — pantalla: "kiosko.fichaje" — práctica: sí
        "profes.fichar": {
            summary: "Aprendés a fichar entrada y salida: en la tablet de la sede con tu PIN o tu QR personal (Mi QR de fichaje), con la huella en el molinete o, sólo en locales sin molinete, desde el celular. Ves cómo leer Mis fichadas, cómo reportar un olvido que corrige el encargado y cómo cargar tu PIN en Mi cuenta.",
            keyPoints: [
                "Tu liquidación se arma con tus fichadas: fichá siempre la entrada al llegar y la salida al irte.",
                "En la tablet fichás desde la pantalla de espera, sin que nadie tenga la sesión abierta, con tu PIN o tu QR personal. No elegís entrada o salida: lo decide el sistema con tu última fichada del día.",
                "El QR de fichaje se renueva solo cada minuto: una captura vieja no sirve.",
                "Desde el celular sólo se ficha en locales sin molinete; donde hay molinete, la fichada va por huella o por la tablet.",
                "Si te olvidás la salida, el sistema la cierra al final del turno y la marca como cerrada automáticamente. Las corregidas aparecen marcadas y la original nunca se borra.",
                "Un olvido lo reportás vos y lo corrige el encargado. El PIN lo cargás vos en Mi cuenta (de cuatro a ocho números) y es tu respaldo si te quedás sin batería.",
            ],
            estimatedMin: 6,
            contentVersion: 2,
        },
        // profes.mi-mes — «Mi mes: la liquidación en curso» — roles: teacher (Profesor) — pantalla: "profes.mi-mes" — práctica: no
        "profes.mi-mes": {
            summary: "Aprendés a seguir tu liquidación mientras pasa el mes en Mi mes: el total proyectado, que suma sólo lo confirmado, las clases con y sin premio, la vara de cada clase con su promedio del mes, el detalle clase por clase con sus componentes, los reemplazos, las pruebas convertidas y los pendientes. Cuando el mes se cierra, pasa a Mis liquidaciones.",
            keyPoints: [
                "Mi mes muestra tu liquidación tal como va, «calculado en vivo»: es tu mes en curso, no un número cerrado.",
                "El total proyectado suma sólo lo confirmado: lo que está en Pendientes del mes todavía no suma.",
                "Una clase con cero presentes se paga sólo si la marcaste «dictada sin alumnos» en Mis clases y el coordinador la validó.",
                "El premio depende de la vara, el piso de presentes de cada clase de tu grilla (día, hora y sede): si la clase la iguala o la supera, sale con premio. Al cerrar el mes se promedian los presentes de las clases que diste: si el promedio supera la vara, la del mes que viene pasa a ese promedio. Nunca baja sola, y una clase nueva no tiene vara su primer mes.",
                "Si reemplazás a alguien, la clase la cobrás vos, con premio si lo generó. Si alguien que probó tu clase se asocia, te suma una hora como prueba convertida.",
                "Sólo ves tu propia liquidación y no se edita nada: si un número no te cierra, avisá a coordinación o administración mientras el mes está abierto.",
            ],
            estimatedMin: 8,
            contentVersion: 4,
        },
        // profes.liquidaciones — «Mis liquidaciones» — roles: teacher (Profesor) — pantalla: "profes.liquidaciones" — práctica: no
        "profes.liquidaciones": {
            summary: "Aprendés a consultar en Mis liquidaciones tus meses cerrados: el total, el detalle clase por clase igual al que ve administración y el PDF. Ves qué cambia si estás en relación de dependencia o si sos externo que factura, y por qué una liquidación cerrada no cambia nunca.",
            keyPoints: [
                "Acá quedan los meses cerrados; el mes en curso lo ves en Mi mes.",
                "Si estás en relación de dependencia, el sistema no emite recibos de sueldo: arma el cálculo que va al estudio contable, que es lo que ves acá.",
                "Si sos externo que factura, el total de cada mes es el monto contra el que emitís tu factura, y ves si está pendiente o si administración ya la recibió.",
                "Al abrir un mes ves el detalle clase por clase (horas, premios, pruebas convertidas y ajustes) y lo podés descargar en PDF.",
                "Una liquidación cerrada no cambia nunca: cada renglón guarda la tarifa, el multiplicador, los presentes y la vara del día. Un error se corrige como ajuste en la liquidación siguiente.",
                "Sólo ves las tuyas. «Sin liquidaciones cerradas todavía» es real; «no se pudo leer» no quiere decir que no tengas nada.",
            ],
            estimatedMin: 5,
            contentVersion: 2,
        },
        // profes.clases-avisos — «Mis clases y avisos» — roles: teacher (Profesor) — pantalla: "profes.mis-clases" — práctica: no
        "profes.clases-avisos": {
            summary: "Aprendés a usar Mis clases (presentes sobre cupo de cada clase, reemplazos y pruebas agendadas sin datos de contacto), a marcar una clase como «dictada sin alumnos» y a avisar una ausencia con motivo, que le llega al coordinador sin cancelar la clase. También usás el centro de Avisos: pruebas agendadas, cancelaciones, marcar leído y ver la clase.",
            keyPoints: [
                "Presentes son los que escanearon el QR, socios y visitantes de convenio; las reservas sin presente no cuentan. «Completa» es sólo informativo: el premio depende de la vara.",
                "Si fuiste y no vino nadie, marcás «Dictada sin alumnos» el mismo día. No se liquida sola: la valida el coordinador y recién ahí se paga.",
                "Avisar ausencia pide un motivo y le llega al coordinador para conseguir reemplazo; no cancela la clase. Si te reemplazan, la cobra quien la dicte.",
                "De las pruebas agendadas ves nombre, edad y actividad de interés, sin teléfono ni mail: el contacto queda en recepción. Si la persona se asocia, te suma una hora como prueba convertida.",
                "En Avisos te llegan las pruebas agendadas y las cancelaciones de tu grilla; con Ver la clase vas a la lista. «Sin registrar» en una prueba no quiere decir que no vino.",
                "No podés cancelar una clase ni cambiar el cupo. Sin legajo el sistema no sabe cuáles son tus clases: pedíselo a Administración.",
            ],
            estimatedMin: 6,
            contentVersion: 2,
        },
        // profes.privacidad — «Qué ves de un socio, y qué no» — roles: teacher (Profesor) — pantalla: null — práctica: no
        "profes.privacidad": {
            summary: "Entendés qué ves de un socio en el portal y qué no: nombre, estado en la lista, marcas (visitante de convenio, prueba, extra impago) y las lesiones y objetivos declarados, sólo de tus clases; de las pruebas, nombre, edad y actividad. Nunca ves teléfono, mail, dirección, deuda ni pagos. No es desconfianza: es la regla de acceso a datos de contacto y de salud, y protege al socio y a vos.",
            keyPoints: [
                "En la lista ves el nombre de cada alumno, si reservó, si escaneó y a qué hora, y las marcas: visitante de convenio, clase de prueba o extra impago, sin montos.",
                "Las lesiones y objetivos declarados los ves con el ícono, sólo de los alumnos de tus clases: es información de salud y no se comparte fuera de la clase.",
                "De quien viene a probar ves nombre, edad y actividad que le interesa; el contacto lo maneja recepción.",
                "Nunca ves teléfono, mail, dirección, deuda ni historial de pagos: lo único con pesos en tu portal es tu propia liquidación.",
                "Si un alumno pregunta por su cuota, su plan o su deuda, o te cuenta una lesión nueva, lo derivás a recepción. No pidas ni anotes datos de contacto por fuera del sistema.",
                "No podés abrir la ficha completa de un socio ni ver la liquidación de otro profe.",
            ],
            estimatedMin: 4,
            contentVersion: 2,
        },
    },
    questions: [
        // ── profes.inicio-agenda ──────────────────────────────────────────────────────
        {
            id: "profes.inicio-agenda#1",
            lessonKey: "profes.inicio-agenda",
            prompt: "Tu clase siempre se llena y querés subirle el cupo. ¿Qué hacés?",
            options: [
                { id: "a", text: "Lo cambiás desde tu agenda en el portal." },
                { id: "b", text: "Se lo planteás a Coordinación: el cupo no se toca desde acá." },
                { id: "c", text: "Dejás pasar a más gente: el cupo es orientativo." },
                {
                    id: "d",
                    text: "Le pedís a recepción que te habilite para editar la grilla desde tu portal.",
                },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, desde el portal no podés cancelar clases, cambiar cupos ni tocar la grilla: eso es de Coordinación, para que la grilla tenga un solo dueño.",
        },
        {
            id: "profes.inicio-agenda#2",
            lessonKey: "profes.inicio-agenda",
            prompt: "Mirás tu agenda durante la clase y en presentes dice «sin consolidar» en lugar de un número. ¿Qué significa?",
            options: [
                { id: "a", text: "Que no vino nadie a la clase." },
                { id: "b", text: "Que la clase quedó cancelada." },
                { id: "c", text: "Que hubo un error al cargar la lista y hay que avisar a Coordinación." },
                { id: "d", text: "Que la asistencia todavía no se cerró." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, mientras la clase no se consolida los presentes dicen «sin consolidar», no cero. A los quince minutos de empezada la asistencia se cierra y aparece el número real.",
        },
        {
            id: "profes.inicio-agenda#3",
            lessonKey: "profes.inicio-agenda",
            prompt: "Te llega el aviso de que tu clase de las 19 no tiene inscriptos a una hora de empezar. A las 18:30 se anota una persona. ¿Qué pasa?",
            options: [
                { id: "a", text: "La clase se da igual: ese aviso no cancela nada." },
                { id: "b", text: "La clase ya quedó cancelada con el aviso." },
                { id: "c", text: "La cancelás vos desde la agenda." },
                { id: "d", text: "Esperás que recepción te confirme si se da." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, el aviso de cero inscriptos no cancela nada: si hay un solo anotado, la clase se da igual.",
        },
        {
            id: "profes.inicio-agenda#4",
            lessonKey: "profes.inicio-agenda",
            prompt: "Mañana tenés un turno médico y no vas a poder dar tu clase. ¿Cómo avisás?",
            options: [
                {
                    id: "a",
                    text: "Por WhatsApp al grupo de profes, así se enteran todos más rápido que por el portal.",
                },
                { id: "b", text: "Cancelás la clase desde tu agenda." },
                { id: "c", text: "Avisás tu ausencia desde el portal apenas lo sabés." },
                { id: "d", text: "Le pedís a un compañero que la dé, sin avisar a nadie." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, la ausencia se avisa por el portal apenas lo sabés: le llega a Coordinación para el reemplazo. Por el portal queda registrado; por WhatsApp depende de que alguien lo lea.",
        },
        // ── profes.tomar-lista ────────────────────────────────────────────────────────
        {
            id: "profes.tomar-lista#1",
            lessonKey: "profes.tomar-lista",
            prompt: "Juana Prueba está en el salón pero se quedó sin batería y no pudo escanear el QR. Quedan cinco minutos de tolerancia. ¿Qué hacés?",
            options: [
                { id: "a", text: "Nada: si no escaneó, queda ausente." },
                { id: "b", text: "La mandás a recepción a que la anoten." },
                { id: "c", text: "La buscás en Reservados y tocás Presente." },
                { id: "d", text: "Consolidás y después le pedís a Coordinación que la corrija." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, si alguien está en el salón pero no pudo escanear, lo buscás en Reservados y tocás Presente, dentro de los quince minutos de tolerancia.",
        },
        {
            id: "profes.tomar-lista#2",
            lessonKey: "profes.tomar-lista",
            prompt: "Llega alguien sin reserva y tocás Sumar walk-in. ¿Qué verifica el sistema antes de sumarlo?",
            options: [
                { id: "a", text: "Que haya cupo y que su plan se lo permita." },
                { id: "b", text: "Nada: lo suma siempre que vos lo marques." },
                { id: "c", text: "Sólo que tenga la app instalada." },
                { id: "d", text: "Que pague la clase en el momento, porque viene sin reserva." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, un walk-in entra sólo si hay cupo y si su plan se lo permite: el sistema lo verifica en el momento y, si no puede, te dice por qué.",
        },
        {
            id: "profes.tomar-lista#3",
            lessonKey: "profes.tomar-lista",
            prompt: "Consolidás la lista y dos reservados no marcaron presente. ¿Qué pasa con ellos?",
            options: [
                { id: "a", text: "Quedan como reservados hasta la próxima clase." },
                { id: "b", text: "Se les devuelve la clase como crédito." },
                { id: "c", text: "Pasan a presentes, porque habían reservado." },
                { id: "d", text: "Pasan a ausentes y les suma falta." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, al consolidar el sistema te avisa cuántos reservados no marcaron presente: pasan a ausentes y les suma falta.",
        },
        {
            id: "profes.tomar-lista#4",
            lessonKey: "profes.tomar-lista",
            prompt: "Ya consolidaste y te das cuenta de que un alumno que estaba quedó ausente porque se cortó internet en el local. ¿Qué hacés?",
            options: [
                {
                    id: "a",
                    text: "Reabrís la lista desde la agenda y lo marcás presente, que todavía estás a tiempo.",
                },
                { id: "b", text: "Avisás enseguida a Coordinación, que la corrige con motivo." },
                { id: "c", text: "Lo marcás presente en la clase siguiente para compensar." },
                { id: "d", text: "Nada: una vez consolidada no tiene arreglo." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, una vez consolidada la lista se congela y vos ya no la cambiás. La corrige Coordinación desde la ficha de la clase, con motivo, y queda en la auditoría.",
        },
        // ── profes.fichar ─────────────────────────────────────────────────────────────
        {
            id: "profes.fichar#1",
            lessonKey: "profes.fichar",
            prompt: "Das clase en un local con molinete y querés fichar desde el celular, en Mis fichadas. ¿Se puede?",
            options: [
                {
                    id: "a",
                    text: "Sí: desde el celular se puede fichar en cualquier local, haya o no molinete.",
                },
                { id: "b", text: "Sólo si fichás con PIN." },
                { id: "c", text: "Sí, si le avisás antes al encargado." },
                { id: "d", text: "No: ahí va por huella o por la tablet." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, desde el celular se ficha sólo en los locales que no tienen molinete. Donde hay molinete, el celular no vale.",
        },
        {
            id: "profes.fichar#2",
            lessonKey: "profes.fichar",
            prompt: "Querés fichar en la tablet mostrando una captura de tu QR de fichaje que guardaste ayer. ¿Funciona?",
            options: [
                { id: "a", text: "Sí: el QR personal es siempre el mismo, por eso se puede guardar." },
                { id: "b", text: "No: el QR se renueva cada minuto." },
                { id: "c", text: "Sólo si la tablet tiene cámara." },
                { id: "d", text: "Sólo en locales sin molinete." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, el QR de fichaje se renueva solo cada minuto, así que una captura vieja no sirve: tiene que ser el de ese momento.",
        },
        {
            id: "profes.fichar#3",
            lessonKey: "profes.fichar",
            prompt: "Ayer te olvidaste de fichar la entrada. ¿Qué hacés?",
            options: [
                { id: "a", text: "Reportás el olvido y le pasás el aviso al encargado, que lo corrige." },
                {
                    id: "b",
                    text: "Corregís vos la fichada en Mis fichadas, cargando la hora a la que llegaste en realidad.",
                },
                { id: "c", text: "Fichás dos veces hoy para compensar." },
                { id: "d", text: "Nada: el sistema la completa solo." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, vos no corregís tus fichadas: reportás el olvido y le pasás el aviso al encargado, que carga la corrección con su motivo.",
        },
        {
            id: "profes.fichar#4",
            lessonKey: "profes.fichar",
            prompt: "Llegás a la sede con el celular sin batería, así que no tenés tu QR. ¿Cómo fichás?",
            options: [
                { id: "a", text: "No podés fichar hasta cargar el celular." },
                { id: "b", text: "Con el celular de un compañero." },
                { id: "c", text: "En la tablet con tu PIN: es tu respaldo." },
                { id: "d", text: "Le pedís a recepción que lo anote en papel." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, en la tablet podés fichar con tu PIN o con tu QR, y si te quedaste sin batería el PIN es tu respaldo. Si no lo tenés, lo cargás vos en Mi cuenta.",
        },
        // ── profes.mi-mes ─────────────────────────────────────────────────────────────
        {
            id: "profes.mi-mes#1",
            lessonKey: "profes.mi-mes",
            prompt: "Fuiste a dar una clase y no vino nadie. En Mi mes esa clase no suma. ¿Por qué?",
            options: [
                {
                    id: "a",
                    text: "Porque las clases sin alumnos nunca se pagan, aunque hayas ido a darlas igual.",
                },
                {
                    id: "b",
                    text: "Porque falta que la marques «dictada sin alumnos» y la valide el coordinador.",
                },
                { id: "c", text: "Porque es un error del cálculo en vivo." },
                { id: "d", text: "Porque se suma sola recién al cierre del mes." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, lo que no está confirmado no suma: una clase con cero presentes se paga sólo si la marcaste como dictada sin alumnos y el coordinador la validó.",
        },
        {
            id: "profes.mi-mes#2",
            lessonKey: "profes.mi-mes",
            prompt: "Tu clase de Pole de los lunes tiene vara 6. Una clase del mes tuvo 6 presentes. ¿Sale con premio?",
            options: [
                { id: "a", text: "No: tiene que superar la vara." },
                { id: "b", text: "Sólo si la clase estaba completa." },
                { id: "c", text: "Depende de lo que decida el coordinador." },
                { id: "d", text: "Sí: si la clase iguala o supera la vara, sale con premio." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, la vara es el piso de presentes de cada clase: si la clase la iguala o la supera, sale con premio.",
        },
        {
            id: "profes.mi-mes#3",
            lessonKey: "profes.mi-mes",
            prompt: "Reemplazaste a un compañero en una clase que generó premio. ¿Quién la cobra?",
            options: [
                { id: "a", text: "Vos, con el premio." },
                { id: "b", text: "El titular de la clase." },
                { id: "c", text: "Se reparte entre los dos." },
                { id: "d", text: "Vos, pero el premio queda para el titular de la clase." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, si reemplazás a alguien esa clase la cobrás vos, con premio si lo generó.",
        },
        {
            id: "profes.mi-mes#4",
            lessonKey: "profes.mi-mes",
            prompt: "A mitad de mes ves en Mi mes un número que no te cierra. ¿Qué hacés?",
            options: [
                { id: "a", text: "Lo editás desde el detalle del mes." },
                {
                    id: "b",
                    text: "Esperás al cierre del mes para reclamar, cuando el número ya sea definitivo.",
                },
                { id: "c", text: "Avisás a coordinación o a administración en ese momento." },
                { id: "d", text: "Lo corregís en Mis liquidaciones." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, desde Mi mes no se edita nada: si un número no te cierra, avisá a coordinación o a administración mientras el mes está abierto, así se corrige a tiempo.",
        },
        // ── profes.liquidaciones ──────────────────────────────────────────────────────
        {
            id: "profes.liquidaciones#1",
            lessonKey: "profes.liquidaciones",
            prompt: "Revisando un mes ya cerrado, ves que faltó pagarte una clase. ¿Cómo se corrige?",
            options: [
                {
                    id: "a",
                    text: "Administración abre esa liquidación cerrada y la edita para sumar la clase.",
                },
                { id: "b", text: "La corregís vos desde el detalle del mes." },
                { id: "c", text: "Se corrige como ajuste en la liquidación siguiente." },
                { id: "d", text: "No se puede corregir." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, una liquidación cerrada no cambia nunca más. Si encontrás un error, avisale a administración: se corrige como ajuste en la liquidación siguiente.",
        },
        {
            id: "profes.liquidaciones#2",
            lessonKey: "profes.liquidaciones",
            prompt: "Sos externo y facturás. ¿Qué monto va en tu factura de un mes?",
            options: [
                { id: "a", text: "El total de ese mes cerrado en Mis liquidaciones." },
                { id: "b", text: "El total proyectado de Mi mes." },
                { id: "c", text: "Lo que calcules vos con tus horas." },
                { id: "d", text: "Lo que te diga recepción." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, si sos externo que factura, el total de cada mes cerrado es el monto contra el que emitís tu factura, y al lado ves si administración ya la recibió.",
        },
        {
            id: "profes.liquidaciones#3",
            lessonKey: "profes.liquidaciones",
            prompt: "Estás en relación de dependencia y buscás tu recibo de sueldo en Mis liquidaciones. ¿Qué encontrás?",
            options: [
                { id: "a", text: "El recibo de sueldo firmado." },
                { id: "b", text: "Nada: esa pantalla es sólo para los externos que facturan." },
                { id: "c", text: "Un recibo provisorio hasta que firme el Dueño." },
                { id: "d", text: "El cálculo que va al estudio contable." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, si estás en relación de dependencia el sistema no emite recibos de sueldo: arma el cálculo que va al estudio contable, y es exactamente lo que ves.",
        },
        {
            id: "profes.liquidaciones#4",
            lessonKey: "profes.liquidaciones",
            prompt: "Entrás a Mis liquidaciones y dice que no se pudo leer. ¿Qué significa?",
            options: [
                {
                    id: "a",
                    text: "Que no tenés ninguna liquidación cerrada todavía y tu mes está en Mi mes.",
                },
                { id: "b", text: "Que no es que no tengas nada: probá más tarde." },
                { id: "c", text: "Que te falta el legajo." },
                { id: "d", text: "Que tus meses están en cero." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, si no se pudo leer no es que no tengas nada: probá más tarde y, si sigue, avisá. Distinto es «sin liquidaciones cerradas todavía», que sí es real.",
        },
        // ── profes.clases-avisos ──────────────────────────────────────────────────────
        {
            id: "profes.clases-avisos#1",
            lessonKey: "profes.clases-avisos",
            prompt: "Tu clase tuvo 8 reservas y 6 personas escanearon el QR. ¿Cuántos presentes cuentan?",
            options: [
                { id: "a", text: "8, porque todos los que reservaron cuentan como presentes." },
                { id: "b", text: "6: los que escanearon el QR." },
                { id: "c", text: "7, el promedio." },
                { id: "d", text: "Ninguno hasta que valide el coordinador." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, presentes son los que escanearon el QR, socios y visitantes de convenio. Las reservas sin presente no cuentan.",
        },
        {
            id: "profes.clases-avisos#2",
            lessonKey: "profes.clases-avisos",
            prompt: "Tocás Avisar ausencia con el motivo «tengo un turno médico». ¿Qué pasa con la clase?",
            options: [
                { id: "a", text: "Queda cancelada y la app les avisa a todos los inscriptos." },
                { id: "b", text: "Se cancela sola si nadie la toma en una hora." },
                { id: "c", text: "Sigue a tu nombre y la cobrás igual." },
                { id: "d", text: "No se cancela: le llega al coordinador." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, el aviso de ausencia no cancela la clase: le llega al coordinador para que consiga reemplazo, y si te reemplazan la cobra quien la dicte.",
        },
        {
            id: "profes.clases-avisos#3",
            lessonKey: "profes.clases-avisos",
            prompt: "En Pruebas agendadas ves que mañana viene alguien a probar tu clase y querés escribirle para presentarte. ¿Qué datos tenés?",
            options: [
                { id: "a", text: "Nombre, edad y actividad que le interesa." },
                { id: "b", text: "Su teléfono, para mandarle un WhatsApp de bienvenida." },
                { id: "c", text: "Su mail, para escribirle." },
                { id: "d", text: "Todos sus datos de la ficha." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, de las pruebas agendadas ves nombre, edad y actividad que le interesa, sin teléfono ni mail: el contacto queda en recepción.",
        },
        {
            id: "profes.clases-avisos#4",
            lessonKey: "profes.clases-avisos",
            prompt: "Una clase de prueba tuya figura con resultado «sin registrar». ¿Qué significa?",
            options: [
                { id: "a", text: "Que la persona no vino." },
                { id: "b", text: "Que la persona ya se asoció." },
                { id: "c", text: "Que todavía nadie cargó el resultado." },
                { id: "d", text: "Que la prueba se canceló." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, «sin registrar» no quiere decir que no vino: quiere decir que todavía nadie lo cargó.",
        },
        // ── profes.privacidad ─────────────────────────────────────────────────────────
        {
            id: "profes.privacidad#1",
            lessonKey: "profes.privacidad",
            prompt: "Al lado del nombre de un alumno ves la marca de extra impago. ¿Qué te dice?",
            options: [
                { id: "a", text: "Cuánto debe de cuota." },
                { id: "b", text: "Que no puede tomar la clase." },
                { id: "c", text: "Que esa clase extra todavía no se pagó." },
                { id: "d", text: "Que se la tenés que cobrar vos antes de empezar la clase." },
            ],
            correctOptionId: "c",
            explanation: "Como viste en el video, la marca de extra impago sólo avisa que esa clase extra todavía no se pagó. No ves montos, y la plata no pasa por vos.",
        },
        {
            id: "profes.privacidad#2",
            lessonKey: "profes.privacidad",
            prompt: "Antes de la clase un alumno te cuenta que se lesionó la rodilla, y el ícono de su nombre no muestra nada de eso. ¿Qué hacés?",
            options: [
                { id: "a", text: "Lo tenés en cuenta y le pedís que lo actualice en recepción." },
                {
                    id: "b",
                    text: "Lo anotás en tu cuaderno junto con su teléfono, por si necesitás llamarlo.",
                },
                { id: "c", text: "Lo comentás con el grupo para que lo cuiden." },
                { id: "d", text: "Lo cargás vos en su ficha desde el portal." },
            ],
            correctOptionId: "a",
            explanation: "Como viste en el video, si te cuenta una lesión o limitación nueva que no ves en el ícono, le pedís que la actualice en recepción para que quede en su ficha. Y no anotás datos por fuera del sistema.",
        },
        {
            id: "profes.privacidad#3",
            lessonKey: "profes.privacidad",
            prompt: "Un alumno te pregunta cuánto debe de cuota. ¿Qué hacés?",
            options: [
                { id: "a", text: "Lo buscás en tu portal, en la lista de la clase." },
                { id: "b", text: "Le decís un monto aproximado." },
                { id: "c", text: "Le cobrás vos y después lo pasás a recepción." },
                { id: "d", text: "Lo derivás a recepción." },
            ],
            correctOptionId: "d",
            explanation: "Como viste en el video, nunca ves la deuda ni el historial de pagos de un socio. Si te pregunta por su cuota, su plan o su deuda, lo derivás a recepción.",
        },
        {
            id: "profes.privacidad#4",
            lessonKey: "profes.privacidad",
            prompt: "Otro profe te pregunta qué lesión declaró una alumna tuya. ¿Qué corresponde?",
            options: [
                { id: "a", text: "Se la contás, porque los dos trabajan en el mismo club." },
                { id: "b", text: "No la compartís: es información de salud." },
                { id: "c", text: "Le mostrás el ícono desde tu celular." },
                { id: "d", text: "Le decís que la busque en su portal." },
            ],
            correctOptionId: "b",
            explanation: "Como viste en el video, las lesiones y objetivos los ves sólo de los alumnos de tus clases, para adaptar la clase. Es información de salud: queda entre vos y el alumno y no se comparte fuera de la clase.",
        },
    ],
};
//# sourceMappingURL=profes.js.map